import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="glass-nav">
      <div className="section-shell flex flex-col gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between">
        <Link to="/" className="brand-mark text-2xl text-slate-900">
          SignAI
        </Link>

        <div className="flex flex-wrap items-center gap-5 text-sm font-semibold md:text-base">
          <Link to="/" className="nav-link">
            Home
          </Link>
          <Link to="/live" className="nav-link">
            Live Detection
          </Link>
          <Link to="/how" className="nav-link">
            How It Works
          </Link>
          <Link to="/research" className="nav-link">
            Research
          </Link>
          <Link to="/team" className="nav-link">
            Team
          </Link>
          <Link to="/accessibility" className="nav-link">
            Accessibility
          </Link>
        </div>
      </div>
    </nav>
  );
}
